export { default } from "./DatoCmsContainedImage";
